import {useCallback} from "react";
import {call} from "redux-saga/effects";

import {useSagaCallback} from "../utils/sagas";
import {apiPost} from "./client";

export const useSetPassword = (feedbackCh) => {
    return useSagaCallback(feedbackCh, useCallback(function* (oldPassword, newPassword, confirmNewPassword) {
        yield call(apiPost, `/api/v2/user/password`, {
            oldPassword,
            newPassword,
            confirmNewPassword
        });
    }, []))
};